import styles from './styles.module.scss';
import cn from 'classnames';
import { InlineSvg } from 'components/svg';
import { ReactNode, useState } from 'react';

type CollapsiblePanelProps = {
  title: ReactNode;
  children: ReactNode;
  defaultExpanded?: boolean;
  collapsible?: boolean;
  className?: string;
  headerActions?: ReactNode;
  headerContent?: ReactNode;
};

export const CollapsiblePanel = ({
  title,
  children,
  defaultExpanded = true,
  collapsible = true,
  className,
  headerActions,
  headerContent
}: CollapsiblePanelProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpand = () => {
    if (collapsible) {
      setIsExpanded(!isExpanded);
    }
  };

  const effectiveExpanded = collapsible ? isExpanded : true;

  return (
    <div className={cn(styles.collapsiblePanel, className)}>
      <div className={styles.header}>
        <div className={styles.headerLeft} onClick={toggleExpand} aria-expanded={effectiveExpanded}>
          <span className={cn('badge', 'badge-light-secondary', styles.title)}>{title}</span>
          {headerContent}
        </div>
        <div className={styles.headerActions}>
          {headerActions}
          {collapsible && (
            <div
              className={cn('cursor-pointer', styles.chevron, { [styles.expanded]: effectiveExpanded })}
              onClick={toggleExpand}
              aria-expanded={effectiveExpanded}
            >
              <InlineSvg
                path="/media/workshop-log/collapsible.svg"
                className="svg-icon-2"
                svgClassName="text-primary"
              />
            </div>
          )}
        </div>
      </div>

      {effectiveExpanded && <div className={styles.content}>{children}</div>}
    </div>
  );
};
